export const AccountTypesEnum = {
    Savings: { label: 'Savings', value: 'Savings' },
    Current: { label: 'Current', value: 'Current' },
    Joint: { label: 'Joint', value: 'Joint' },
  };